module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slide-content",
    class: {
      'is-visible': _vm.visible
    }
  }, [_c('div', {
    staticClass: "slide-content__hd"
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_c('i', {
    staticClass: "el-icon-close"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "slide-content__bd"
  }, [(_vm.visible) ? _vm._t("default") : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@9.9.5@vue-loader/lib/template-compiler.js?id=data-v-42803d05!./~/_vue-loader@9.9.5@vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/TheSlideBox.vue
// module id = 454
// module chunks = 11